import { createContext, useMemo } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';

export const ThemeContext = createContext();

export const ThemeContextProvider = ({ children }) => {
  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          background: {
            default: '#ffffff',
          },
        },
      }),
    []
  );

  return (
    <ThemeContext.Provider value={{}}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  );
};
